import { Legend } from "recharts";

const BaseLegend = Legend

export default BaseLegend;